import defaultTo from 'lodash/defaultTo';
import * as yup from 'yup';

import type { JobFunction } from '../../../../../../graphql/__generated__';
import type { SalesCoverageUnderwriterEmployeeDetailFragment } from '../graphql/__generated__';

export type UserDetailsFormValues = {
  employeeKey: string;
  name: string;
  titles: string[];
  department: string;
  jobFunction: JobFunction | null;
  email1: string;
  email2: string;
  phoneNumber1: string;
  phoneNumber2: string;
  faxNumber1: string;
  faxNumber2: string;
  address1: string;
  address2: string;
};

export const USER_DETAIL_FIELD_LABELS: Record<keyof UserDetailsFormValues, string> = {
  employeeKey: 'Employee Key',
  name: 'Name',
  titles: 'Titles',
  department: 'Department',
  jobFunction: 'Job Function',
  email1: 'Email Address (Primary)',
  email2: 'Email Address (Secondary)',
  phoneNumber1: 'Phone (Primary)',
  phoneNumber2: 'Phone (Secondary)',
  faxNumber1: 'Fax (Primary)',
  faxNumber2: 'Fax (Secondary)',
  address1: 'Address (Primary)',
  address2: 'Address (Secondary)',
};

export const userDetailsUpdateValidationSchema = yup.object({
  name: yup.string().label(USER_DETAIL_FIELD_LABELS.name).trim(),
  titles: yup.array().of(yup.string().label(USER_DETAIL_FIELD_LABELS.titles).trim()),
  department: yup.string().label(USER_DETAIL_FIELD_LABELS.department).trim(),
  jobFunction: yup.mixed<JobFunction>().label(USER_DETAIL_FIELD_LABELS.jobFunction).nullable(),
});

export const userDetailsCreateValidationSchema = userDetailsUpdateValidationSchema.shape({
  employeeKey: yup.string().label(USER_DETAIL_FIELD_LABELS.employeeKey).trim().required(),
});

export const getInitialUserDetailsValues = (
  employee: SalesCoverageUnderwriterEmployeeDetailFragment
): UserDetailsFormValues => ({
  employeeKey: defaultTo(employee.employeeKey, ''),
  name: defaultTo(employee.name, ''),
  titles: defaultTo(
    employee.titles?.filter((title): title is string => typeof title === 'string'),
    []
  ),
  department: defaultTo(employee.department, ''),
  jobFunction: defaultTo(employee.jobFunction, null),
  email1: defaultTo(employee.email1, ''),
  email2: defaultTo(employee.email2, ''),
  phoneNumber1: defaultTo(employee.phoneNumber1, ''),
  phoneNumber2: defaultTo(employee.phoneNumber2, ''),
  faxNumber1: defaultTo(employee.faxNumber1, ''),
  faxNumber2: defaultTo(employee.faxNumber2, ''),
  address1: defaultTo(employee.address1, ''),
  address2: defaultTo(employee.address2, ''),
});

export const SECTIONS_SIZING = {
  xs: 12,
  sm: 12,
  md: 6,
  lg: 4,
  xl: 4,
};
